import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import HorarioRangos from "pages/miakey/config/rangos/HorarioRangos";

export default function EstadoModal({
    horarioId, closeModal, service
}) {
    return (
        <>
            <HorarioRangos horarioId={horarioId} service={service} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}